import type { FC } from 'react'

import { Popup } from '@skytech/ui'
import { sanitizeAndInsertTargetBlank } from '@skytech/utils/html-sanitization'

export const FeatureSalesPitchModal: FC<{
  salesPitch: string
  onClose: () => void
}> = ({ salesPitch, onClose }) => (
  <Popup ariaLabel="sales-pitch" isOpen={Boolean(salesPitch)} onClose={onClose} variant="wide">
    <div dangerouslySetInnerHTML={{ __html: sanitizeAndInsertTargetBlank(salesPitch) }} />
  </Popup>
)
